export const NOTIFICATION_SETTINGS_STORAGE_KEY = 'ahshoot-notification-settings';

export const DEFAULT_NOTIFICATION_SETTINGS = {
  pushEnabled: true,
  scheduleNoticeEnabled: true,
  voteNoticeEnabled: true,
  joinRequestNoticeEnabled: true,
};

export const NOTIFICATION_SETTINGS_CHANGED_EVENT =
  'ahshoot:notification-settings-changed';

export const PUSH_DEVICE_STORAGE_KEY = 'ahshoot-push-device';
export const PUSH_TOKEN_SYNC_SIGNATURE_KEY = 'ahshoot-push-sync-signature';

export const NATIVE_PUSH_TOKEN_REQUEST_TYPE = 'AHSHOOT_REQUEST_PUSH_TOKEN';
export const NATIVE_PUSH_TOKEN_RESPONSE_TYPES = ['AHSHOOT_PUSH_TOKEN', 'PUSH_TOKEN'];
